import { dateParse, fullTimeParse, numberParse } from "@/utils/pureFunctions";

export default {
  install(Vue) {
    Vue.filter("dateParse", (val) => {
      return dateParse(val);
    });

    Vue.filter("fullTimeParse", (val) => {
      return fullTimeParse(val);
    });

    Vue.filter("numberParse", (val) => {
      return numberParse(val);
    });
  },
};
